module.exports = __webpack_public_path__ + "img/li4.9fd58721.png";